export default {"src":"/_next/static/media/NeckPainandStrains.9fbff396.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};